// @flow

import compteApi from '../../network/api/compteApi';
import { MonIdentite } from '../../network/api/types/compte/MonIdentite';
import { store } from '../reduce';
import { SAVE_DYNAMIC_KEYS_LIST } from './userReducer';
import { CompteMonidentiteModifyDTO } from '../../network/api/types/compte/CompteMonidentiteModifyDTO';
import { notifyErrorWithMessage } from '../../components/common/Notification';
import { ResponseDTO } from '../../network/api/types/ResponseDTO';

export const saveMyIdentity = (dynamicKeys: MonIdentite) =>
  (dispatch: (any) => void):void => {
    dispatch(store(SAVE_DYNAMIC_KEYS_LIST, dynamicKeys));
  };

export const fetchMyIdentity = () =>
  (dispatch: (any) => void):Promise<void> => compteApi.fetchMyIdentity()
    .then((myIdentity) =>
      dispatch(saveMyIdentity(myIdentity)));

export const updateMyIndentity = (infos: CompteMonidentiteModifyDTO) =>
  (dispatch: (any) => void): Promise<ResponseDTO> =>
    compteApi.modifyMyIdentity(infos)
      .then(() => {
        dispatch(fetchMyIdentity());
      })
      .catch((err) => {
        if (typeof err.then === 'function') {
          return err.then((e) => notifyErrorWithMessage(e.fieldErrors[0].message));
        }
        return null;
      });
